export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  contracts: (state) => state.contracts,
};
